import { gql } from '@apollo/client'

export const SIMPLE_RESTOCK_GROUP_FRAGMENT = gql`
  fragment SimpleRestockGroup on RestockGroup {
    id
    created
    user {
      firstName
      lastName
    }
    restocks {
      id
    }
    store {
      id
      location {
        name
      }
    }
    actionComplete {
      action {
        id
        title
        dueDateTime
        dueDate
        actionGenerator {
          id
        }
      }
    }
  }
`
